const shallowMerge = (...args) => {
  return Object.assign({}, ...args);
};

export default shallowMerge;
